(() => {
  const KEY = "ges_favorites_v1";

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  };

  const write = (arr) => {
    localStorage.setItem(KEY, JSON.stringify(arr));
  };

  const has = (handle) => read().includes(handle);

  const toggle = (handle) => {
    const arr = read();
    const i = arr.indexOf(handle);
    if (i >= 0) arr.splice(i, 1);
    else arr.push(handle);
    write(arr);
    return arr;
  };

  const setBtnState = (btn, active) => {
    btn.classList.toggle("is-fav", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  };

  const initButtons = (root = document) => {
    root.querySelectorAll("[data-fav-btn][data-handle]").forEach((btn) => {
      setBtnState(btn, has(btn.dataset.handle));
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    initButtons();
  });

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-fav-btn][data-handle]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const arr = toggle(btn.dataset.handle);
      setBtnState(btn, arr.includes(btn.dataset.handle));

      window.dispatchEvent(
        new CustomEvent("favorites:updated", { detail: { favorites: arr } })
      );
    },
    true
  );

  document.addEventListener("shopify:section:load", (e) => {
    initButtons(e.target);
  });
})();
